import { ImageLoaderCSSStyleImpl } from '../../toolkit/imageloader/imageloadercss';


export class LandingPageImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{

    getImgCSSStyle(): object 
    {
        return {
           width: '100%',
           // objectFit: 'contain', 
            cursor: "pointer",
            // width: "100%",
            // height: "300px",
            // maxWidth: "none",
            borderRadius:'8px',
            height: "100%",
            objectFit: "cover",
            // background: "linear-gradient(90deg, #0F34DB 0%, #E900FF 100%)"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/landingpage/landingpageimageloadercss.tsx